import { FC } from 'react';
import { Tooltip } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { useTranslation } from 'react-i18next';

/**
 * End-adornment marker for bank-configuration fields whose data is embedded in
 * the QR code of the QR payment-slip report (WA-3623). Purely informational — a
 * QR glyph plus a translatable tooltip; no validation is attached, since not
 * every customer uses that report. The underlying data is consumed by the
 * report procedure `my_PR_ReportsInvoice_InvoicePaymentSlip` (field `QRText`):
 * QR-IBAN + creditor name/street/city.
 */
export const QrFieldHint: FC = () => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('settings.qr_field_hint')} arrow>
      <QrCode2Icon fontSize='small' sx={{ color: 'rgba(0, 0, 0, 0.54)', cursor: 'help' }} />
    </Tooltip>
  );
};
